import BooksyLogo from '@images/registration/BooksyLogo.png'
import DekraLogo from '@images/registration/DekraLogo.png'
import HighPerformerMidMarketReward from '@images/registration/HighPerformerMidMarketReward.png'
import HighPerformerReward from '@images/registration/HighPerformerReward.png'
import LeadByteLogo from '@images/registration/LeadByteLogo.png'
import LeadCaptureSmallBusinessReward from '@images/registration/LeadCaptureSmallBusinessReward.png'
import PayuLogo from '@images/registration/PayuLogo.png'
import {
  Heading,
  Icon,
  Image,
  List,
  ListItem,
  Paragraph,
  Spacer,
  Spreader
} from '@landingi/landingi-ui-kit'
import ShapesContainer from '@pages/Authentication/components/SecondColumn/ShapesContainer'
import { useAnimationContext } from '@pages/Authentication/contexts/animation'
import { motion } from 'framer-motion'
import PropTypes from 'prop-types'
import { Fragment, memo } from 'react'
import { Trans } from 'react-i18next'
import { Row } from 'simple-flexbox'

import styles from './RefreshedColumnContent.module.scss'

const LoginVariant = ({ title }) => {
  const { secondColumnControls } = useAnimationContext()

  return (
    <Fragment>
      <ShapesContainer />
      <motion.div
        className={styles['column-content']}
        animate={secondColumnControls}
      >
        <Heading level={1}>
          <Trans i18nKey={title} />
        </Heading>

        <List>
          <ListItem>
            <Row>
              <Icon
                icon='icon-check-circle'
                color='primary'
                className={styles['refreshed-registration-list-icon']}
              />

              <Spreader spread='small' />

              <Paragraph size={16} line={24} padding='none'>
                <Trans i18nKey='registration.flow.login.1st.paragraph' />
              </Paragraph>
            </Row>
          </ListItem>

          <Spacer space='mini' />

          <Spacer space='tiny' />

          <ListItem>
            <Row>
              <Icon
                icon='icon-check-circle'
                color='primary'
                className={styles['refreshed-registration-list-icon']}
              />

              <Spreader spread='small' />

              <Paragraph size={16} line={24} padding='none'>
                <Trans i18nKey='registration.flow.refreshed.2nd.paragraph' />
              </Paragraph>
            </Row>
          </ListItem>

          <Spacer space='mini' />

          <Spacer space='tiny' />

          <ListItem>
            <Row>
              <Icon
                icon='icon-check-circle'
                color='primary'
                className={styles['refreshed-registration-list-icon']}
              />

              <Spreader spread='small' />

              <Paragraph size={16} line={24} padding='none'>
                <Trans i18nKey='registration.flow.refreshed.3rd.paragraph' />
              </Paragraph>
            </Row>
          </ListItem>

          <Spacer space='mini' />

          <Spacer space='tiny' />

          <ListItem>
            <Row>
              <Icon
                icon='icon-check-circle'
                color='primary'
                className={styles['refreshed-registration-list-icon']}
              />

              <Spreader spread='small' />

              <Paragraph size={16} line={24} padding='none'>
                <Trans i18nKey='registration.flow.refreshed.4th.paragraph' />
              </Paragraph>
            </Row>
          </ListItem>
        </List>

        <Spacer />

        <div className={styles['column-content__logos']}>
          <Image src={DekraLogo} size='68px' />
          <Image src={LeadByteLogo} size='78px' />
          <Image src={PayuLogo} size='40px' />
          <Image src={BooksyLogo} size='90px' />
          <Image src={HighPerformerReward} size='54px' />
          <Image src={HighPerformerMidMarketReward} size='54px' />
          <Image src={LeadCaptureSmallBusinessReward} size='54px' />
        </div>
      </motion.div>
    </Fragment>
  )
}

LoginVariant.displayName = 'LoginVariant'

LoginVariant.propTypes = {
  title: PropTypes.string.isRequired
}

export default memo(LoginVariant)
